/**
 * Configuração PIX e dados financeiros da plataforma.
 * Armazenado em localStorage; pode ser sincronizado com API futuramente.
 */

const STORAGE_KEY_PIX = 'navi_admin_pix_config';
const DEFAULT_PIX_CNPJ = '24354289000105';

export interface PixConfig {
  chavePix: string; // CNPJ ou email/telefone/chave aleatória
  tipoChave: 'cnpj' | 'email' | 'telefone' | 'aleatoria';
  nomeTitular: string;
  cidade: string;
  ativo: boolean;
  updatedAt?: string;
}

export function getPixConfig(): PixConfig {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PIX);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<PixConfig>;
      return {
        chavePix: parsed.chavePix ?? DEFAULT_PIX_CNPJ,
        tipoChave: parsed.tipoChave ?? 'cnpj',
        nomeTitular: parsed.nomeTitular ?? 'NAVI EXPERIENCE LTDA',
        cidade: parsed.cidade ?? 'SAO PAULO',
        ativo: parsed.ativo ?? true,
        updatedAt: parsed.updatedAt,
      };
    }
  } catch {
    /* ignore */
  }
  return {
    chavePix: DEFAULT_PIX_CNPJ,
    tipoChave: 'cnpj',
    nomeTitular: 'NAVI EXPERIENCE LTDA',
    cidade: 'SAO PAULO',
    ativo: true,
  };
}

export function savePixConfig(config: Partial<PixConfig>): PixConfig {
  const current = getPixConfig();
  const merged: PixConfig = {
    ...current,
    ...config,
    updatedAt: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY_PIX, JSON.stringify(merged));
  return merged;
}
